<input
    type="text"
    [(ngModel)]="base64ResultContent"
    id="takePhotoInput"
    class="take-photo-input"
/>
